module.exports = __webpack_public_path__ + "static/media/rolnikon_tool_en.c5d0bd38.png";